export default  {
    component: 'pages',
    name: 'pages',
    fields: [
        {
            param: 'user_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
        {
            param: 'plant_id',
            type: 'number',
            required: true,
            identifier: true,
            hidden: true
          },
          {
            name: 'Role',
            param: 'role',
            type: 'text'
          },
          {
            name: 'Pages',
            param: 'pages',
            type: 'text'
          },
          {
            name: 'SCB Pages',
            param: 'scb_pages',
            type: 'text'
          },
          {
            name: 'SCB Pages Config',
            param: 'scb_pages_config',
            type: 'json'
          }

  // device_id
  // inverter_name
  // added_on
  // updated_on
  // updated_by
  // inverter_room
    ]
  }

